<!--
 * @Author: cmchiu
 * @Date: 2023-04-28 10:47:46
 * @LastEditTime: 2023-05-13 14:17:16
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\views\Home.vue
 * 
-->
<template>
    <div class="home-page">
        <!-- Banner -->
        <banner />

        <div class="container">
            <!-- 搜尋框 -->
            <div class="search w-100 d-flex justify-content-center">
                <div class="search__set d-flex justify-content-between flex-wrap">
                    <div class="search__item">
                        <input
                            type="text"
                            class="search__input"
                            placeholder="找專家"
                            @keyup.enter="search('teacher', $event.target.value)"
                        />
                    </div>
                    <div class="search__item">
                        <input
                            type="text"
                            class="search__input"
                            placeholder="找計畫"
                            @keyup.enter="search('project', $event.target.value)"
                        />
                    </div>
                    <div class="search__item">
                        <input
                            type="text"
                            class="search__input"
                            placeholder="找儀器"
                            @keyup.enter="search('instrument', $event.target.value)"
                        />
                    </div>
                </div>
            </div>
            <!-- 研發成果與技轉 -->
            <news-r-d />
            <!-- 產學新聞 -->
            <news-i-a />
        </div>
        <!-- 快速入口 -->
        <entries />
        <!-- 聯絡我們 -->
        <div class="contact w-100 d-flex justify-content-center align-items-center flex-wrap">
            <button class="contact__btn">
                <router-link :to="{ path: '/contact' }">聯絡我們</router-link>
            </button>
            <p class="contact__description">
                如果對於文大產學合作媒合想要更多的了解<br />
                探索雙方合作機會 非常歡迎您線上洽詢與我們聯絡
            </p>
        </div>
    </div>
</template>

<script>
import { banner, newsRD, newsIA, entries } from '@c'

export default {
    name: 'home',

    components: { banner, newsRD, newsIA, entries },

    data() {
        return {}
    },

    created() {},

    methods: {
        search(searchType, keyword) {
            const vm = this
            switch (searchType) {
                case 'teacher':
                    vm.$router.push({ name: '0210', params: { keyword } })
                    // vm.$router.push({ path: '/teacher/TeacherSearch', query: { keyword } })
                    break
                case 'project':
                    vm.$router.push({ name: '0400', params: { keyword } })
                    // vm.$router.push({ path: '/project/ProjectSearch', query: { keyword } })
                    break
                case 'instrument':
                    vm.$router.push({ name: '0310', params: { keyword } })
                    // vm.$router.push({ path: '/instrument/InstrumentSearch', query: { keyword } })
                    break
            }
        },
    },
}
</script>
